export default __webpack_public_path__ + "static/media/card-icon.dd8f7db2.png";